import { useMutation } from '@tanstack/react-query';
import { resetPassword } from '../../users';

import { ALERT_STATUS, useAlert } from '../../../contexts/AlertContext';

const useForgotPassword = (handleSuccess) => {
	const { handleAlert } = useAlert();

	const { mutate: handleForgotPassword, isPending } = useMutation({
		mutationFn: ({ email }) => resetPassword({ email }),
		onSuccess: handleSuccess,
		onError: (error) => {
			handleAlert(ALERT_STATUS.ERROR, error.response.data.error);
		},
	});

	return { handleForgotPassword, isPending };
};

export default useForgotPassword;
